module.exports = __webpack_public_path__ + "static/media/AWS_color.294c1ba0.bmp";